import HeroSection from "../components/home/HeroSection";
import MapSection from "../components/home/MapSection";
import AboutSection from "../components/home/AboutSection";
import ContactSection from "../components/home/ContactSection";

export default function Home() {
  return (
    <>
      <HeroSection />
      <MapSection />
      <AboutSection />
      <ContactSection />
    </>
  );
}
